import React, { useRef, useState, useEffect } from 'react';

const useCardRefs = (allCards, currentTab) => {
  const cardRefs = useRef({}); // Will store { cardId: React.RefObject }
  const [refsAreAttached, setRefsAreAttached] = useState(false);

  useEffect(() => {
    // Create or update refs for all cards
    const newCardRefs = {};
    allCards.forEach(card => {
      // Ensure a ref object exists for each card ID, reuse if possible
      newCardRefs[card.id] = cardRefs.current[card.id] || React.createRef();
    });
    cardRefs.current = newCardRefs;
    setRefsAreAttached(true); // Signal that refs are prepared for attachment
  }, [allCards, currentTab]);

  return { cardRefs: cardRefs.current, refsAreAttached };
};

export default useCardRefs;
